import React, { Component } from 'react';
import { Svg } from '../Gauge';
import { GaugeLeftVerticalLabel } from './GaugeLeftVerticalLabel';
import { GaugeRightHorizontalLabel } from './GaugeRightHorizontalLabel';
import { GaugeCenterLabel } from './GaugeCenterLabel';
import { GaugeBoundLabel } from './GaugeBoundLabel';

export interface GaugeLabelsProps {
   svg: Svg;
   svgId: string;
   value: number;
   upperBound: number;
   lowerBound: number;
   centerLabelColor: string;
   labelsColor: string;
   displayCenterLabel: boolean;
   displayBoundsLabels: boolean;
   leftVerticalLabel: string;
   centerLabel: string;
   rightHorizontalLabel: string;
   prePendCharacter: string;
   postPendCharacter: string;
}

export class GaugeLabelGroup extends Component<GaugeLabelsProps> {
   render(): JSX.Element {
      const svg: Svg = this.props.svg;
      const svgId: string = this.props.svgId;
      const labelsColor: string = this.props.labelsColor;

      return (
         <>
            {this.props.displayBoundsLabels && <GaugeBoundLabel
               svg={svg}
               svgId={svgId}
               upperBound={this.props.upperBound}
               lowerBound={this.props.lowerBound}
               labelsColor={labelsColor}
               prePendCharacter={this.props.prePendCharacter}
               postPendCharacter={this.props.postPendCharacter}
            />}
            {this.props.leftVerticalLabel && <GaugeLeftVerticalLabel
               svg={svg}
               svgId={svgId}
               labelsColor={labelsColor}
               leftVerticalLabel={this.props.leftVerticalLabel}
            />}
            {this.props.displayCenterLabel && <GaugeCenterLabel
               svg={svg}
               svgId={svgId}
               value={this.props.value}
               centerLabelColor={this.props.centerLabelColor}
               centerLabel={this.props.centerLabel}
               prePendCharacter={this.props.prePendCharacter}
               postPendCharacter={this.props.postPendCharacter}
            />}
            {this.props.rightHorizontalLabel && <GaugeRightHorizontalLabel
               svg={svg}
               svgId={svgId}
               labelsColor={labelsColor}
               rightHorizontalLabel={this.props.rightHorizontalLabel}
            />}
         </>
      );
   }
}
